import React, { useMemo } from 'react';
import ComboSelector, { TipoClave } from './ComboSelector.js';

const CampoComboAnio = (props) => {
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;
  const estilo = props.estilo;
  const anioInicio = props.anioInicio || 1891;
  const anioFin = props.anioFin || new Date().getFullYear() + 1;

  // Crear la lista de años como objetos para ComboSelector
  const listaAnios = useMemo(() => {
    const lista = [];
    for (let i = anioFin; i >= anioInicio; i--) {
      lista.push({ anio: i, descripcion: String(i) });
    }
    return lista;
  }, [anioInicio, anioFin]);

  const onChange = (anioSeleccionado) => {
    // Si es null o undefined, pasar null
    // Si es un objeto con la propiedad anio, extraer el valor
    const anioValue = anioSeleccionado?.anio || null;
    props.onChange(nombre, anioValue);
  };

  // Encontrar el objeto del año actual en la lista
  const valorActual = useMemo(() => {
    if (!valor) return '';
    const anioObj = listaAnios.find((a) => a.anio === valor);
    return anioObj ? anioObj.descripcion : String(valor);
  }, [valor, listaAnios]);

  let campo = '';
  if (editar) {
    campo = (
      <ComboSelector
        estilo={estilo}
        lista={listaAnios}
        valorActual={valorActual}
        campoClave={TipoClave.ID}
        campoDescripcion="descripcion"
        isCargando={false}
        onItemElegido={onChange}
      />
    );
  } else {
    campo = valor || '';
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoComboAnio;
